module.exports = __webpack_public_path__ + "static/media/Wrigley.0047e683.jpg";